import NewsOnboarding from "./NewsOnboarding";

export default NewsOnboarding;
